import images from "../../images";
import translate from "../../Utils/translate";
import FieldInput from "../Form/Fields/FieldInput";

const Search = ({ query, setQuery }) => {
  const icon = query?.length ? images.icons.cross : images.icons.search;

  return (
    <div className="mb-default">
      <FieldInput
        floatingLabel={false}
        icon={icon}
        onChange={(event) => setQuery(event.target.value)}
        onClick={() => setQuery("")}
        placeholder={translate("forms.search.placeholder")}
        value={query}
      />
    </div>
  );
};

export default Search;
